<template>
    <div class="fun_mo">
        <!-- Logo -->
        <div class="fun_hero">
            <div class="fun_logo_wrap">
                <img class="fun_logo" src="../../../static/fun/logo.png" alt="HABBY FUN">
            </div>
        </div>

        <!-- Who We Are / HEART OVER HYPE：标题+正文均居中 -->
        <div class="fun_about">
            <div class="fun_about_row">
                <div class="fun_about_title">{{ t.whoWeAreMo }}</div>
                <div class="fun_about_desc">{{ t.whoWeAreDesc }}</div>
            </div>
            <div class="fun_about_row">
                <div class="fun_about_title">{{ t.heartOverHypeMo }}</div>
                <div class="fun_about_desc">{{ t.heartOverHypeDesc }}</div>
            </div>
        </div>

        <!-- Our Fun Games -->
        <div class="fun_games">
            <div class="fun_games_title">{{ t.ourFunGamesMo }}</div>
            <div class="fun_games_list">
                <img
                    class="fun_game_icon"
                    src="../../../static/fun/game_piroker.png"
                    alt="Piroker"
                >
                <div class="fun_game_placeholder">
                    <span class="fun_game_placeholder_text">{{ t.comingSoon }}</span>
                </div>
            </div>
        </div>

        <!-- Contact：左右排布 -->
        <div class="fun_contact">
            <span class="fun_contact_label">{{ t.contactLabel }}</span>
            <a class="fun_contact_mail" :href="'mailto:' + t.contactEmail">{{ t.contactEmail }}</a>
        </div>
    </div>
</template>

<script>
import funLogic from './logic.js'

export default {
    name: 'FunMobile',
    mixins: [funLogic],
}
</script>

<style scoped lang="less">
@import "./mobile.less";
</style>



// WEBPACK FOOTER //
// src/pages/fun/FunMobile.vue